import { Injectable } from '@angular/core';
import { CommonConstants } from '../utilities/commonConstants';
import { SessionHandlerService } from './sessionHandler.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClevertapEventHandlerService {

  clevertap: any;

  constructor(
    private _sessionHandlerService: SessionHandlerService
  ) {
  }
  
  public cleverTapUserCreation(userProfileData: any) {
    window['clevertap'].onUserLogin.push({
      "Site": userProfileData
    });
    console.log("clevertap", 'Identity', userProfileData);
  }

  public cleverTapEventPush(eventName: string, propertyData: any) {
    if (environment.isCleverTapEnabled && this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.MobileState) != '1') {
      try {
        console.log("clevertap", eventName, propertyData);
        window['clevertap'].event.push(eventName, propertyData);
      } catch (error) {
        console.log('error', error);
      }
    }
  }
  
  public clevertapEvents(eventName: string, propertyData: any) {
    if (environment.isCleverTapEnabled && this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.MobileState) == '1') {
      window['clevertap'].event.push(eventName, propertyData);
      console.log("clevertap", eventName, propertyData);
    }
  }

  public onUserLogin(customerId: Number) {
    if (this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.MobileState) != '1') {
      this.cleverTapUserCreation({
        "Identity": "+91" + this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.mobileNumber),
        "Phone": "+91" + this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.mobileNumber),
        "customer_tag": customerId ? "ETB" : "NTB",
        "customer_id": customerId || null
      });
    }
  }

  /* On PLP Page Load */
  public cleverTapOnPLPPageLoad(customerId) {
    const onPageLoadObj: any = {
      "event_type": "identity_set",
      "custom_event": "marketplace_form_event",
      "component": "marketplace_login",
      "element": "marketplace_login_cta",
      "cta_text": "GET QUOTE",
      "page_url": document.URL,
      "page_type": "Product Display Page",
      "product_name": "NA",
      "product_category": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.InsProductType),
      "customer_tag": customerId ? "ETB" : "NTB",
      "customer_id": customerId || null
    };
    this.cleverTapEventPush("click", onPageLoadObj);
  }

  private getcommonClevertapObj() {
    return {
      "EP_SOURCE": CommonConstants.utmSource.organic,
      "EP_MOBILE_NO": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.mobileNumber),
      "EP_VEHICLE_TYPE": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.vehicleType),
    }
  }

  public setCommonCleverTapObjValueInSessionStorage(values: any) {
    const objKeys = Object.keys(values);
    objKeys.forEach((key: string) => {
      this._sessionHandlerService.SetSession(CommonConstants.CookieKeys[key], values[key]);
    });
  }

  public cleverTapForVehicleRegistrationPageCta() {
    const vehicleRegistrationCtaClevertapObj: any = {
      ...this.getcommonClevertapObj(), ...{
        "EP_INSURANCE_PAGE": "MOTORHOME",
        "EP_VEHICLE_NO": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.vehicleRegistrationNumber),
        "EP_MOBILE_NO": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.mobileNumber),
        "EP_PINCODE": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.pinCode),
        "EP_CTA": "GETQUOTE"
      }
    }
    this.clevertapEvents("INSURANCE_PWA_VIEWED", vehicleRegistrationCtaClevertapObj);
  }

  public cleverTapForVehicleDetailsPageCta(cta, outputPayload?) {
    const vehicleDetailsCtaClevertapObj: any = {
      ...this.getcommonClevertapObj(), ...{
        "EP_INSURANCE_PAGE": "VEHICLEDETAILS1",
        "EP_VEHICLE_MAKE": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.vehicleMake),
        "EP_VARIANT": outputPayload['payload'].vehicleVariant ? outputPayload['payload'].vehicleVariant : null,
        "EP_REGISTRATION_YEAR": outputPayload['payload'].registrationDt.split('-')[0] ? outputPayload['payload'].registrationDt.split('-')[0] : null,
        "EP_MANUFACTURING_YEAR": outputPayload['payload'].mfgYear ? outputPayload['payload'].mfgYear : null,
        "EP_CTA": cta
      }
    }
    this.clevertapEvents("INSURANCE_PWA_VIEWED", vehicleDetailsCtaClevertapObj);
  }

  public cleverTapForPlanProductListingPageCta(cta, aemFragmentInfo?, planSummaryObj?, criteria?, vehicleDetails?, selectedNcb?, addOnsAvailable?, plan?) {
    if (aemFragmentInfo) {
      if (plan && aemFragmentInfo.principleName) {
        var partnerName = aemFragmentInfo.principleName.variations[plan.planCode.toLowerCase() + '_' + plan.variantCode.toLowerCase()].value;
      }
    }
    const policyExpiredValue = this._sessionHandlerService.GetSession('IsExpired') == 'false' ? planSummaryObj.policyExpDte : "Already Expired";
    const planTypeName = planSummaryObj['planType'] == 'CP' ? "COMPREHENSIVE PLAN" : "OWN DAMAGE PLAN";
    const planProductListingCtaClevertapObj: any = {
      ...this.getcommonClevertapObj(), ...{
        "EP_INSURANCE_PAGE": "PRODUCTLISTING",
        "EP_VEHICLE_MAKE": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.vehicleMake),
        "EP_INSURANCE_OFFERS": partnerName ? partnerName : null,
        "EP_INSURANCE_QUOTE": plan ? plan.idv : planSummaryObj ? planSummaryObj.idv : null,
        "EP_IDV": plan ? plan.idv : planSummaryObj ? planSummaryObj.idv : null,
        "EP_NCB": plan ? plan.currentNcb : planSummaryObj ? planSummaryObj.currentNcb : null,
        "EP_ADD_ONS": plan?.featuresList?.filter(ele => ele.partnerAvailable) || [],
        "EP_PLAN_TYPE": planTypeName ? planTypeName : null,
        "EP_POLICY_EXPIRY_DATE": policyExpiredValue ? policyExpiredValue : null,
        "EP_VEHICLE_DETAILS": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.vehicleMake),
        "EP_CTA": cta
      }
    }
    this.clevertapEvents("INSURANCE_PWA_VIEWED", planProductListingCtaClevertapObj);
  }

  public cleverTapForBuyNowPolicyDetailsPageCta(cta, aemFragmentInfo?, planSummaryObj?, buyNowPlan?, policyDetailsFormGroup?) {
    if (aemFragmentInfo) {
      if (aemFragmentInfo.principleName) {
        var partnerName = aemFragmentInfo.principleName.variations[buyNowPlan.planCode.toLowerCase() + '_' + buyNowPlan.variantCode.toLowerCase()].value;
      }
    }
    if (policyDetailsFormGroup) {
      var previousPolicyExists = policyDetailsFormGroup.controls['isComp'].value == 'Y1' ? "Yes" : "TP";
    }
    const buyNowPolicyDetailsCtaClevertapObj: any = {
      ...this.getcommonClevertapObj(), ...{
        "EP_INSURANCE_PRODUCTCODE": "MANICIGIGH",
        "EP_INSURANCE_PAGE": "VERIFYDETAILS1",
        'EP_VEHICLE_MAKE': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.vehicleMake),
        "EP_INSURANCE_OFFERS": partnerName ? partnerName : null,
        "EP_INSURANCE_QUOTE": planSummaryObj ? planSummaryObj.idv : null,
        "EP_PREVIOUS_POLICY": previousPolicyExists ? previousPolicyExists : null,
        "EP_CTA": cta,
      }
    }
    this.clevertapEvents("INSURANCE_PWA_VIEWED", buyNowPolicyDetailsCtaClevertapObj);
  }

  public cleverTapForOwnerDetailsPageCta(cta, aemFragmentInfo?, planSummaryObj?, ownerDetailsFormGroup?) {
    if (aemFragmentInfo) {
      if (aemFragmentInfo.principleName) {
        var partnerName = aemFragmentInfo.principleName.variations[planSummaryObj.planCode.toLowerCase() + '_' + planSummaryObj.variantCode.toLowerCase()].value;
      }
    }
    if (ownerDetailsFormGroup && ownerDetailsFormGroup.controls['day'].value && ownerDetailsFormGroup.controls['month'].value && ownerDetailsFormGroup.controls['year'].value) {
      var dob = ownerDetailsFormGroup.controls['day'].value + "/" + ownerDetailsFormGroup.controls['month'].value + "/" + ownerDetailsFormGroup.controls['year'].value;
    }
    const ownerDetailsCtaClevertapObj: any = {
      ...this.getcommonClevertapObj(), ...{
        "EP_INSURANCE_PRODUCTCODE": "MANICIGIGH",
        "EP_INSURANCE_PAGE": "OWNERDETAILS",
        "EP_VEHICLE_MAKE": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.vehicleMake),
        "EP_INSURANCE_OFFERS": partnerName ? partnerName : null,
        "EP_INSURANCE_QUOTE": planSummaryObj ? planSummaryObj.idv : null,
        "EP_NAME": ownerDetailsFormGroup?.controls['fullName'].value ? ownerDetailsFormGroup.controls['fullName'].value : null,
        "EP_DOB": dob ? dob : null,
        "EP_EMAIL": ownerDetailsFormGroup?.controls['emailID'].value ? ownerDetailsFormGroup.controls['emailID'].value : null,
        "EP_PINCODE": ownerDetailsFormGroup?.controls['pinCode'].value ? ownerDetailsFormGroup.controls['pinCode'].value : null,
        "EP_CTA": cta
      }
    }
    this.clevertapEvents("INSURANCE_PWA_VIEWED", ownerDetailsCtaClevertapObj);
  }

  public cleverTapForVehicleDetailPageCta(cta, aemFragmentInfo?, planSummaryObj?, vehicleDetailsFormGroup?) {
    if (aemFragmentInfo) {
      if (aemFragmentInfo.principleName) {
        var partnerName = aemFragmentInfo.principleName.variations[planSummaryObj.planCode.toLowerCase() + '_' + planSummaryObj.variantCode.toLowerCase()].value;
      }
    }
    const vehicleDetailCtaClevertapObj: any = {
      ...this.getcommonClevertapObj(), ...{
        "EP_INSURANCE_PRODUCTCODE": "MANICIGIGH",
        "EP_INSURANCE_PAGE": "VEHICLEDETAILS2",
        "EP_VEHICLE_MAKE": this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.vehicleMake),
        "EP_INSURANCE_OFFERS": partnerName ? partnerName : null,
        "EP_INSURANCE_QUOTE": planSummaryObj ? planSummaryObj.idv : null,
        "EP_ENGINE_NUMBER": vehicleDetailsFormGroup ? vehicleDetailsFormGroup.controls['engineNumber'].value : null,
        "EP_CHASIS_NUMBER": vehicleDetailsFormGroup ? vehicleDetailsFormGroup.controls['chassisNumber'].value : null,
        "EP_LOAN_HYPOTHECATION": vehicleDetailsFormGroup ? vehicleDetailsFormGroup.controls['carFinanced'].value : null,
        "EP_CTA": cta
      }
    }
    this.clevertapEvents("INSURANCE_PWA_VIEWED", vehicleDetailCtaClevertapObj);
  }

  public cleverTapForPreviousPolicyPageCta(cta, aemFragmentInfo?, planSummaryObj?, PreviousPolicyDetailsForm?, insuranceProviders?) {
    if (aemFragmentInfo) {
      if (aemFragmentInfo.principleName) {
        var partnerName = aemFragmentInfo.principleName.variations[planSummaryObj.planCode.toLowerCase() + '_' + planSummaryObj.variantCode.toLowerCase()].value;
      }
    }
    if (PreviousPolicyDetailsForm) {
      if (PreviousPolicyDetailsForm.controls['day'] && PreviousPolicyDetailsForm.controls['month'] && PreviousPolicyDetailsForm.controls['year']) {
        var expiryDate = PreviousPolicyDetailsForm.controls['day'].value + "/" + PreviousPolicyDetailsForm.controls['month'].value + "/" + PreviousPolicyDetailsForm.controls['year'].value;
      }
    }
    if (PreviousPolicyDetailsForm && PreviousPolicyDetailsForm.controls['previousPolicyInsurer'] && insuranceProviders) {
      for (var i = 0; i < insuranceProviders.length; i++) {
        if ((insuranceProviders)[i].insuranceProviderId == PreviousPolicyDetailsForm.controls['previousPolicyInsurer'].value) {
          var providerName = (insuranceProviders)[i].providerName;
        }
      }
    }
    const previousPolicyCtaClevertapObj: any = {
      ...this.getcommonClevertapObj(), ...{
        "EP_INSURANCE_PRODUCTCODE": "MANICIGIGH",
        "EP_INSURANCE_PAGE": "PREVIOUSPOLICY DETAILS",
        'EP_VEHICLE_MAKE': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.vehicleMake),
        "EP_INSURANCE_OFFERS": partnerName ? partnerName : null,
        "EP_INSURANCE_QUOTE": planSummaryObj ? planSummaryObj.idv : null,
        "EP_PREVIOUS_INSURER": providerName ? providerName : null,
        "EP_PREVIOUS_POLICY_NO": PreviousPolicyDetailsForm ? PreviousPolicyDetailsForm.controls['previousPolicyNumber'].value : null,
        "EP_PREVIOUS_POLICY_EXP": expiryDate ? expiryDate : null,
        "EP_CTA": cta,
      }
    }
    this.clevertapEvents("INSURANCE_PWA_VIEWED", previousPolicyCtaClevertapObj);
  }

  public cleverTapForProductReviewPageCta(cta, aemFragmentInfo?, planSummaryObj?) {
    if (aemFragmentInfo) {
      if (aemFragmentInfo.principleName) {
        var partnerName = aemFragmentInfo.principleName.variations[planSummaryObj.planCode.toLowerCase() + '_' + planSummaryObj.variantCode.toLowerCase()].value;
      }
    }
    const productReviewCtaClevertapObj: any = {
      ...this.getcommonClevertapObj(), ...{
        "EP_INSURANCE_PRODUCTCODE": "MANICIGIGH",
        "EP_INSURANCE_PAGE": "DETAILSREVIEWCONFIRM",
        'EP_VEHICLE_MAKE': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.vehicleMake),
        "EP_INSURANCE_OFFERS": partnerName ? partnerName : null,
        "EP_INSURANCE_QUOTE": planSummaryObj ? planSummaryObj.idv : null,
        "EP_CTA": cta
      }
    }
    this.clevertapEvents("INSURANCE_PWA_VIEWED", productReviewCtaClevertapObj);
  }

  public cleverTapForPaymentFailedPageCta(cta, quoteItemDetail?, aemFragmentInfo?, planCode?, summaryData?, paymentStatusResp?) {
    if (aemFragmentInfo) {
      if (aemFragmentInfo.principleName) {
        var partnerName = aemFragmentInfo.principleName.variations[planCode.toLowerCase() + '_' + summaryData.quoteItemDetail[0].productVariantCode.toLowerCase()].value;
      }
    }
    if (quoteItemDetail) {
      var idv = quoteItemDetail.sumassuredamt.toString();
    }
    const paymentFailedCtaClevertapObj: any = {
      ...this.getcommonClevertapObj(), ...{
        "EP_INSURANCE_PAGE": "MOTOR_TRANSACTION_STATUS",
        "EP_INSURANCE_PRODUCTCODE": "MANICIGIGH",
        "PAYMENT_STATUS": paymentStatusResp ? paymentStatusResp.paymentStatus : null,
        "EP_INSURANCE_OFFERS": partnerName ? partnerName : null,
        "EP_INSURANCE_COVERAGE": idv ? idv : null,
        "EP_PAYMENT_INSTRUMENT": paymentStatusResp ? paymentStatusResp.paymentMode : null,
        "EP_TXN_ID": paymentStatusResp ? paymentStatusResp.systemPaymentId : null,
        "EP_AMOUNT": paymentStatusResp ? paymentStatusResp.paymentAmount : null,
        "EP_CTA": cta
      }
    }
    this.clevertapEvents("INSURANCE_PWA_VIEWED", paymentFailedCtaClevertapObj);
  }
}
